import "./Loading.css";

const Loading = () => {
  return (
    <div className="Loading">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
